import { render, staticRenderFns } from "./CampaignsCalendar.vue?vue&type=template&id=1066229b&scoped=true&"
import script from "./CampaignsCalendar.vue?vue&type=script&lang=js&"
export * from "./CampaignsCalendar.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsCalendar.vue?vue&type=style&index=0&id=1066229b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1066229b",
  null
  
)

export default component.exports